<template>
  <div>
    <Layout/>
    <div class="container">
      <div class="breadcrumb-container">
        <router-link to="/plancontable">Plan Contable</router-link>
        > Cuentas
      </div>
      <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
        <div class="notification-message" 
             :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
          {{ notificacion.message }}
        </div>
      </div>
    </div>
    <hr>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoPlanContable.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanContable" class="form-label">IdPlanContable</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="idPlanContable" name="idPlanContable" v-model="datoPlanContable.idPlanContable" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label">IdEmpresa</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoPlanContable.idEmpresa" style='text-transform:uppercase' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-10">
                  <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPlanContable.fechaReg" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                  <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoPlanContable.fechaAct" required>
                  </div>
                </div>
              </div>
            </div>  
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlanContable" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlanContable" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <!-- <th scope="col"></th> -->
          <th scope="col">Código</th>
          <th scope="col">Descripción</th>
          <th scope="col">TipoCuenta</th>
          <th scope="col">Nivel</th>
          <th scope="col">Estado</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cuenta in datosPaginados" :key="cuenta.idCuenta">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(cuenta.idCuenta)" title="Editar">edit_square</i></td>
          <!-- <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(cuenta.idCuenta)" title="Editar">edit_square</i></td> -->
          <td>{{cuenta.codigoCuenta}}</td>
          <td>{{cuenta.nombreCuenta}}</td>
          <td>{{cuenta.tipoCuenta}}</td>
          <td>{{cuenta.nivel}}</td>
          <td>{{cuenta.estado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePlanContable(cuenta.idCuenta)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idCuenta" class="form-label">IdCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idCuenta" name="idCuenta" v-model="datoCuenta.idCuenta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPlanContable" class="form-label">IdPlanContable</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlanContable" name="idPlanContable" v-model="datoCuenta.idPlanContable" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigoCuenta" class="form-label">CodigoCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigoCuenta" name="codigoCuenta" v-model="datoCuenta.codigoCuenta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCuenta" class="form-label">NombreCuenta</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombreCuenta" name="nombreCuenta" v-model="datoCuenta.nombreCuenta" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoCuenta" class="form-label">TipoCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipoCuenta" name="tipoCuenta" v-model="datoCuenta.tipoCuenta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nivel" class="form-label">Nivel</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nivel" name="nivel" v-model="datoCuenta.nivel" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarCuenta" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditCuenta" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      plancontables : [],
      datoPlanContable : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPlanContable: '',
// Variables master
// Variables details
      cuentas : [],
      datoCuenta : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      planContables : [],
      modalWindow: true,
      mostrarBloque: false,
      notificaciones: []
// Variables details
    }
  },
  mounted () {
    this.p_idPlanContable = this.$route.params.p_idplancontable
    this.abrirEditar(this.p_idPlanContable)
    this.getDataPaginaTodos(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'descripcion'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'descripcion'
      ];
      return validarForm(this.datoPlanContable, requiredFields, requiredFieldsText);
    },
    async guardarPlanContable(){
      if(this.validarForm() === 1){
        try {
          this.datoPlanContable.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/plancontables', this.datoPlanContable)
          this.notificaciones.push({ message: "PlanContable creado exitosamente!", type: "success" });
        } catch (error) { 
          this.notificaciones.push({ message: "Intentelo de nuevo!", type: "error" });
        }
      }
    },
    async guardarEditPlanContable(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plancontables', this.datoPlanContable)
          this.notificaciones.push({ message: "PlanContable actualizado exitosamente!", type: "success" });
        } catch (error) {
          this.notificaciones.push({ message: "Intentelo de nuevo!", type: "error" });
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPlanContable={}
      this.titulo   = 'Crear Plan Contable'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPlanContable){
      this.modalWindow = true
      if(idPlanContable != null){    
           api.get('/vwplancontables/'+idPlanContable).then(resp=>{
          this.datoPlanContable = resp.data;
           });
      }
      this.titulo   = 'Editar Plan Contable'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPlanContable(){
      this.$router.push('/PlanContable')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.cuentas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcuentas/nombre/'+this.nombreBusqueda).then(response=>{
          this.cuentas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.cuentas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcuentas').then(response=>{
      this.cuentas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.cuentas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'descripcion'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'descripcion'
      ];
      return validarForm(this.datoPlanContable, requiredFields, requiredFieldsText);
    },
    async guardarCuenta(){
      if(this.validarForm() === 1){
        try {
          this.datoCuenta.idPlanContable = this.datoPlanContable.idPlanContable;
          await api.post('/cuentas', this.datoCuenta)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Cuenta creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCuenta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/cuentas', this.datoCuenta)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Cuenta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoCuenta={}
      this.titulo   = 'Crear Plan Contable'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idCuenta){
      this.modalWindow = true
      if(idCuenta != null){    
           api.get('/vwcuentas/'+idCuenta).then(resp=>{
          this.datoCuenta = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Plan Contable'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
/*     abrirEditarDet(idCuenta){
      this.modalWindow = true
      if(idCuenta != null){
        this.$router.push('/cuentamd/'+idCuenta)
      }
    }, */
    async deleteCuenta (idCuenta) {
      try{
        await api.delete('/cuentas/'+idCuenta)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPlanContables() {
      fetch('http://localhost:8080/api/v1/plancontables')
        .then(response => response.json())
        .then(data => {
          this.planContables = data;
        })
        .catch(error => {
          console.error('Error fetching planContables:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/alertas.css" scoped></style>
